function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#202124",
  fillRule: "nonzero",
  stroke: "#202124"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M20.591 3.588c-.265-.516-.8-.838-1.381-.838H4.81c-.583 0-1.117.322-1.382.838-.268.522-.212 1.148.142 1.615l6.09 8.011v7.504c0 .584.336 1.116.863 1.373.521.255 1.142.2 1.61-.143l1.598-1.174c.393-.288.626-.744.626-1.23v-6.33l6.091-8.01c.356-.467.411-1.094.143-1.616zm-1.336.708l-6.245 8.212c-.1.13-.153.29-.153.454v6.582c0 .006-.004.014-.013.021l-1.599 1.174c-.017.012-.043.015-.064.004-.014-.007-.02-.017-.02-.025v-7.756c0-.164-.055-.324-.154-.454L4.764 4.296c-.005-.008-.006-.015-.002-.022.006-.013.025-.024.047-.024h14.4c.023 0 .041.01.048.024.004.007.003.014-.002.021h0z",
  transform: "translate(-227 -216) translate(13 200) translate(214 16)"
})))));

var SvgIconFilter = function SvgIconFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-filter.ee0b95d2.svg";
export { ForwardRef as ReactComponent };